import { Http } from '@/lib/http';

export class PastDueDaysRangeService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/past-due-days-range-settings';
  }

  fetchPastDueDaysRanges(params) {
    return this.httpClient().get(`${this.endpoint}`, { params });
  }

  updatePastDueDaysRange(updates) {
    return this.httpClient().put(`${this.endpoint}`, updates);
  }
}
